var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Truck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.8333 13.3332V4.99984C10.8333 4.5396 10.4602 4.1665 10 4.1665H3.33333C2.8731 4.1665 2.5 4.5396 2.5 4.99984V13.3332C2.5 13.7934 2.8731 14.1665 3.33333 14.1665H4.16667M10.8333 13.3332C10.8333 13.7934 10.4602 14.1665 10 14.1665H7.5M10.8333 13.3332L10.8333 6.6665C10.8333 6.20627 11.2064 5.83317 11.6667 5.83317H13.8215C14.0425 5.83317 14.2545 5.92097 14.4107 6.07725L17.2559 8.92243C17.4122 9.07871 17.5 9.29067 17.5 9.51168V13.3332C17.5 13.7934 17.1269 14.1665 16.6667 14.1665H15.8333M10.8333 13.3332C10.8333 13.7934 11.2064 14.1665 11.6667 14.1665H12.5M4.16667 14.1665C4.16667 15.087 4.91286 15.8332 5.83333 15.8332C6.75381 15.8332 7.5 15.087 7.5 14.1665M4.16667 14.1665C4.16667 13.246 4.91286 12.4998 5.83333 12.4998C6.75381 12.4998 7.5 13.246 7.5 14.1665M12.5 14.1665C12.5 15.087 13.2462 15.8332 14.1667 15.8332C15.0871 15.8332 15.8333 15.087 15.8333 14.1665M12.5 14.1665C12.5 13.246 13.2462 12.4998 14.1667 12.4998C15.0871 12.4998 15.8333 13.246 15.8333 14.1665",
    stroke: "#111418",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleNotification);
export default __webpack_public_path__ + "static/media/vehicle-notification.ebae3a3cdc8fc9f9755cf4514ca0f972.svg";
export { ForwardRef as ReactComponent };